import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getList = params => {
  return axios.request({
    url: "/shipments/intercept",
    params,
    method: "get"
  });
};
export const update = data => {
  return axios.request({
    url: "/shipments/intercept/updateStatus",
    data,
    method: "post"
  });
};